export default "__VITE_ASSET__ClYOgLro__"